import { addDays, formatDay, zonedDay } from './format.js';

/** "Today" / "Yesterday" / the short M/D day every other logistics date
 *  reads in — on the SITE's calendar, not the viewer's. Yesterday is a
 *  CALENDAR day back, so a 23- or 25-hour DST day still lands on the right
 *  date. */
export function wasteRecency(iso: string, now: Date, lang: string, tz: string, t: (k: string) => string): string {
  const synced = zonedDay(iso, tz);
  const today = zonedDay(now.toISOString(), tz);
  if (synced === today) return t('logistics.waste.today');
  if (synced === addDays(today, -1)) return t('logistics.waste.yesterday');
  return formatDay(synced, lang);
}
